const dbName = 'commDB';
const dbVersion = 1;

//indexedDB 데이터베이스를 생성하는 부분
const openIndexedDB = (storeName) => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(dbName, dbVersion);
        // indexedDB 테이블을 생성하는 부분
        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(storeName)) {
                db.createObjectStore(storeName, {
                    keyPath: 'id', //objectStore에 키 값 모든 넘기는 모든 객체들은 id값을 갖고 있어야한다 그래서 자동으로 생성
                    autoIncrement: true, //id 값이 자동으로 생성 1씩 증가하는 형식
                });
            }
        };
        request.onsuccess = (event) => {
            resolve(event.target.result);
        };

        request.onerror = (event) => {
            reject(event.target.error);
        }
    });
}

//objectStore 에 있는 데이터 갖고오기
function getObjectStore(db, mode, storeName) {
    return db.transaction(storeName, mode).objectStore(storeName);
}


//objectStore 에 값을 저장
export const saveObjStore = (data, storeName) => {
    return openIndexedDB(storeName).then((db) => {
        return new Promise((resolve, reject) => {
            const store = getObjectStore(db, 'readwrite', storeName);
            const request = store.add({data});

            request.onsuccess = (event) => {
                resolve();
            }

            request.onerror = (event) => {
                reject(event.target.error);
            }
        })
    })
};

//objectStore 에 담긴 값을 전체 조회
export const getAllObjStore = (storeName) => {
    return openIndexedDB(storeName).then((db) => {
        return new Promise((resolve, reject) => {
            const store = getObjectStore(db, 'readonly', storeName);
            const request = store.getAll();
            request.onsuccess = (event) => {
                resolve(event.target.result);
            }

            request.onerror = (event) => {
                reject(event.target.error);
            }
        })
    })
}

//objectStore 에 담긴 값을 하나만 조회
export const getObjStore = (storeName,id) => {
    return openIndexedDB(storeName).then((db) => {
        return new Promise((resolve, reject) => {
            const store = getObjectStore(db, 'readonly', storeName);
            const request = store.get(id);
            request.onsuccess = (event) => {
                resolve(event.target.result);
            }

            request.onerror = (event) => {
                reject(event.target.error);
            }
        })
    })
}

//objectStore 에 담긴 값을 삭제
export const deleteObjectStore = (storeName,id) => {
    return openIndexedDB(storeName).then((db) => {
        return new Promise((resolve, reject) => {
            const store = getObjectStore(db,'readwrite', storeName);
            const request = store.delete(id);

            request.onsuccess = () => {
                resolve();
            }

            request.onerror = (event) => {
                reject(event.target.error);
            }
        })
    })
}


// 데이터 베이스를 삭제하는 부분
export const deleteIndexedDB = () => {
    indexedDB.deleteDatabase(dbName);
}


